import { Scaffold } from 'layouts';
import { PendingStocks } from 'components/Pages/ScheduledReports';

export const PendingStocksPage = () => {
  return (
    <Scaffold>
      <PendingStocks />
    </Scaffold>
  );
};
